import React, { useEffect, useRef, useState } from 'react'
import App from '../LayoutMobile'
import { Card, ConfigProvider, Form, message, Pagination, Popover, Table, Input, Select, Button, Space, Popconfirm, Typography, Col, Row, Tag, Checkbox } from 'antd'
import { DeleteOutlined, EditOutlined, EyeInvisibleOutlined, EyeTwoTone, PlusOutlined, SearchOutlined, EyeOutlined, HolderOutlined } from "@ant-design/icons";
import { data } from '../../test';
import { QuestionCircleOutlined } from '@ant-design/icons';
import './Addclinic.css'
import axios from 'axios';
import { Editor } from '@tinymce/tinymce-react';
import { Config } from '../Common/Config';
import useDebounce from '../Common/useDebounce';
import { DndContext, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import { arrayMove, SortableContext, useSortable, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
const { Option } = Select;
const { TextArea } = Input;
const { Title } = Typography;

/** Derive initials from clinic name */
const getInitials = (name = '') => {
  const words = (name || '').trim().split(/\s+/).filter(Boolean);
  if (words.length >= 2) return (words[0][0] + words[1][0]).toUpperCase();
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return '?';
};

/** Drag handle icon for the clinic order column */
const DragHandle = () => (
  <HolderOutlined style={{ cursor: 'grab', color: '#999', fontSize: '16px' }} />
);

/** Sortable <tr> used by the clinic table's dnd-kit reorder */
const DraggableRow = (props) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: props['data-row-key'],
  });

  const style = {
    ...props.style,
    transform: CSS.Transform.toString(transform),
    transition,
    cursor: 'move',
    ...(isDragging ? { position: 'relative', zIndex: 9999 } : {}),
  };

  return <tr {...props} ref={setNodeRef} style={style} {...attributes} {...listeners} />;
};

/** Teal gradient section divider */
const SectionDivider = ({ label }) => (
  <div className="clinician-section-divider" style={{ display: 'flex', alignItems: 'center', gap: 8, margin: '16px 0 10px' }}>
    <div style={{ height: 1, flex: 1, background: 'linear-gradient(90deg, #c5e8e8 0%, #e0f5f5 60%, transparent 100%)', borderRadius: 2 }} />
    <span style={{ fontSize: 11, fontWeight: 700, color: '#008385', whiteSpace: 'nowrap', letterSpacing: 0.5, textTransform: 'uppercase' }}>{label}</span>
    <div style={{ height: 1, flex: 1, background: 'linear-gradient(90deg, transparent 0%, #e0f5f5 40%, #c5e8e8 100%)', borderRadius: 2 }} />
  </div>
);


const Addclinic = () => {
  const MAX_CHARS = 250;
  const charCountRefs = useRef({});
  const editorRef = useRef(null);
  const [inputSearchValue, setinputSearchValue] = useState('');
  const [form] = Form.useForm();
  const [clinicDataSetInUpdate, setclinicDataSet] = useState({})
  const [allClinicData, setallClinicData] = useState([])
  const [loader, setloader] = useState(false)
  const [showPriceBucket, setshowPriceBucket] = useState(null)
  const [allbucketData, setallbucketData] = useState([])
  const [CurrentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [isClinicCreateEnable, setisClinicCreateEnable] = useState(false)
  const [messageApi, contextHolder] = message.useMessage();
  const [showAddButton, setshowAddButton] = useState(true)
  const [editTextArea, seteditTextArea] = useState(null)
  const [showEditorOnlyAdd, setshowEditorOnlyAdd] = useState(true)
  const debouncedInputValue = useDebounce(inputSearchValue, 800);
  const [productsData, setproductsData] = useState(null)
  const [metaData, setmetaData] = useState(null)
  const [formMode, setFormMode] = useState('edit')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const isViewMode = formMode === 'view'
  const hasFetched = useRef(false);
  const [draggedData, setDraggedData] = useState([]);
  const isSearchActive = !!inputSearchValue?.trim();
  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 1 } })
  );

  useEffect(() => {
    const fetchAll = async () => {
      await getAllMetaData()
    };
    fetchAll();
  }, []);
  useEffect(() => {

    let allProduct = [], ClinicianTypeById = {}
    if (metaData && metaData && metaData.length > 0) {
      metaData.map(cat => {
        allProduct.push({
          label: cat.meta_value,
          value: cat.meta_id,
        })
        ClinicianTypeById[`${cat.meta_id}`] = cat.meta_value

      })
      // console.log('allProduct::', allProduct)
      // setshowClinicianTypeById(ClinicianTypeById)
      setproductsData(allProduct)
    } else {
      setproductsData(allProduct)
    }
  }, [metaData]);
  useEffect(() => {
    if (!hasFetched.current) {
      getAllClinicData(CurrentPage, null, pageSize)
      hasFetched.current = true;
    }
  }, [CurrentPage, pageSize])

  useEffect(() => {
    // console.log('debouncedInputValue :::',debouncedInputValue)
    if (debouncedInputValue) {
      getAllClinicData(CurrentPage, debouncedInputValue, pageSize)
    }
  }, [debouncedInputValue])
  useEffect(() => {
    getAllBucketsData()
  }, [])

  // Keep the draggable copy of the list in sync with the latest fetch
  useEffect(() => {
    if (allClinicData?.data) {
      setDraggedData(allClinicData.data)
    }
  }, [allClinicData])

  const getAllMetaData = async () => {
    if (!localStorage.getItem('token')) return;
    try {
      const response = await axios.get(`${Config.urlLogin}/api/v1/meta-data`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        params: { category: "clinician_type" }
      });
      if (response?.data?.data && response?.data?.data.data) {
        setmetaData(response?.data?.data.data);
      }
    } catch (error) {
      console.log('error in get clinic data ::::', error)
    }
  };
  const getAllClinicData = async (CurrentPage = 1, searchData = null, size = pageSize) => {
    setloader(true)
    // admin/v1/clinic/search/page/1?name=street
    let url = `${Config.url}clinic/page/${CurrentPage}?per_page=${size}`
    if (searchData) {
      url = `${Config.url}clinic/search/page/${CurrentPage}?name=${searchData}&per_page=${size}`
    }
    try {
      const response = await axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      setallClinicData(response?.data?.data)
      setloader(false)
      hasFetched.current = false;
    } catch (error) {
      console.log('error in get clinic data ::::', error)
      messageApi.error({
        type: 'error',
        content: error.response?.data?.message || error.message || "Something went wrong",
      });
      setloader(false)
    }
  }
  // Send the reordered page slice's clinic_id/sort_order to the backend.
  // sort_order is a single global sequence across the whole paginated list,
  // so ranks must be offset by the current page, not restarted at 1.
  const updateClinicOrder = async (orderedPageSlice) => {
    const perPage = allClinicData?.per_page || 10
    const baseRank = (CurrentPage - 1) * perPage
    const order = orderedPageSlice.map((item, index) => ({
      clinic_id: item.id,
      sort_order: baseRank + index + 1,
    }))
    try {
      await axios.put(`${Config.url}clinic/update-order`, { order }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      })
      messageApi.success({
        type: 'success',
        content: 'Clinic order updated successfully',
      });
    } catch (error) {
      console.log('error in clinic/update-order ::::', error)
      messageApi.error({
        type: 'error',
        content: error.response?.data?.message || error.message || 'Failed to update clinic order',
      });
      // Revert the optimistic reorder — fall back to the last known-good server order
      setDraggedData(allClinicData?.data || [])
    }
  }
  const onDragEnd = ({ active, over }) => {
    if (active.id !== over?.id) {
      setDraggedData((prevData) => {
        const activeIndex = prevData.findIndex((i) => i.id === active.id)
        const overIndex = prevData.findIndex((i) => i.id === over?.id)
        const newData = arrayMove(prevData, activeIndex, overIndex)
        updateClinicOrder(newData)
        return newData
      })
    }
  }
  const getAllBucketsData = async () => {
    setloader(true)
    try {
      const response = await axios.get(`${Config.url}clinic-bucket-pricing`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      if (response?.data?.data) {
        let bucketDropDown = [], bucketObj = {}
        if (response?.data?.data && response?.data?.data?.data) {
          response?.data?.data?.data.map(buc => {
            bucketDropDown.push({
              label: buc.bucket_name,
              value: buc.id
            })
            bucketObj[buc.id] = buc.bucket_name
          })
          setallbucketData(bucketDropDown)
          setshowPriceBucket(bucketObj)
        }

      } else {

      }

      setloader(false)
    } catch (error) {
      console.log('error in get clinic data ::::', error)
      setloader(false)
    }
  }
  const baseColumns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 100,
      render: (_, record) => (
        <div>
          {record?.status == 1 ? 'Active' : 'Inactive'}
        </div>
      ),
    },
    {
      title: 'Main Widget',
      dataIndex: 'is_hidden_from_main_widget',
      key: 'is_hidden_from_main_widget',
      width: 120,
      render: (_, record) => (
        <Tag style={{
          color: record?.is_hidden_from_main_widget ? '#ff4d4f' : '#008385',
          borderColor: record?.is_hidden_from_main_widget ? '#ff4d4f' : '#008385',
          background: record?.is_hidden_from_main_widget ? '#fff1f0' : '#e6f5f5',
          margin: 0,
        }}>
          {record?.is_hidden_from_main_widget ? 'Hidden' : 'Visible'}
        </Tag>
      ),
    },
    {
      title: 'Price bucket',
      dataIndex: 'price_bucket_id',
      key: 'price_bucket_id',
      width: 120,
      render: (_, record) => (
        <div>
          {showPriceBucket && showPriceBucket[record.price_bucket_id] ? showPriceBucket[record.price_bucket_id] : record.price_bucket_id}
        </div>
      ),
    },
    {
      title: 'WebSite URL',
      dataIndex: 'website_url',
      key: 'website_url',
    },
    {
      title: '',
      key: 'action',
      width: 48,
      render: (_, record) => (
        <div style={{ textAlign: 'right' }} onClick={(e) => e.stopPropagation()}>
          <Popover
            placement="left"
            trigger="click"
            content={() => content(record)}
            overlayInnerStyle={{ padding: '6px 0', minWidth: 140 }}
          >
            <button
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: '4px 8px',
                borderRadius: 6,
                color: '#008385',
                fontSize: 16,
                fontWeight: 700,
                letterSpacing: 2,
                lineHeight: 1,
                display: 'inline-flex',
                alignItems: 'center',
              }}
              title="Actions"
            >
              ...
            </button>
          </Popover>
        </div>
      ),
    },
  ];
  // Reordering only makes sense against the unfiltered, globally-ranked list —
  // hide the drag handle (and the DnD wrapper, see render below) while a name search is active.
  const columns = isSearchActive
    ? baseColumns
    : [{ key: 'sort', width: 50, render: () => <DragHandle /> }, ...baseColumns];

  const openClinicRecord = (record, viewMode = true) => {
    setshowAddButton(false)
    setisClinicCreateEnable(true)
    setFormMode(viewMode ? 'view' : 'edit')
    setloader(true)
    seteditTextArea(null)
    setshowEditorOnlyAdd(false)

    let newrooms = []
    record?.rooms && record?.rooms.length && record?.rooms.map((ele) => {
      let obj = {
        ...ele,
        clinician_type: Number(ele.clinician_type),
      }
      newrooms.push(obj)
    })

    form.setFieldsValue({
      ...record,
      is_hidden_from_main_widget: Boolean(record?.is_hidden_from_main_widget),
      rooms: newrooms,
      price_bucket_id: showPriceBucket && showPriceBucket[record.price_bucket_id] ? { value: record.price_bucket_id, label: showPriceBucket[record.price_bucket_id] } : record.price_bucket_id
    });
    setclinicDataSet(record)
    setloader(false)
    document.querySelector(".clinicCreate-form")?.scrollIntoView({ behavior: "smooth" });
  }

  const actionItemStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '8px 16px',
    cursor: 'pointer',
    fontSize: 13,
    fontWeight: 500,
    color: '#008385',
    transition: 'background 0.15s',
    userSelect: 'none',
    textDecoration: 'none',
  };

  const content = (record) => (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {/* View */}
      <a
        style={actionItemStyle}
        onClick={(e) => { e.stopPropagation(); openClinicRecord(record, true); }}
        onMouseEnter={e => e.currentTarget.style.background = '#f0fafa'}
        onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
      >
        <EyeOutlined style={{ fontSize: 15 }} />
        View
      </a>

      {/* Edit */}
      <a
        style={actionItemStyle}
        onClick={(e) => { e.stopPropagation(); openClinicRecord(record, false); }}
        onMouseEnter={e => e.currentTarget.style.background = '#f0fafa'}
        onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
      >
        <EditOutlined style={{ fontSize: 15 }} />
        Edit
      </a>

      {/* Divider */}
      <div style={{ height: 1, background: '#f0f0f0', margin: '2px 0' }} />

      {/* Delete */}
      <Popconfirm
        title="Delete Clinic"
        description="Are you sure you want to permanently delete this clinic?"
        onConfirm={() => deleteUser(record)}
        icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
        okButtonProps={{ className: 'confirmation-popup-ok-button' }}
        cancelButtonProps={{ className: 'confirmation-popup-cancel-button' }}
        okText="Yes, Delete"
        cancelText="Cancel"
        placement="left"
      >
        <a
          style={{ ...actionItemStyle, color: '#ff4d4f' }}
          onMouseEnter={e => e.currentTarget.style.background = '#fff1f0'}
          onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
          onClick={(e) => e.stopPropagation()}
        >
          <DeleteOutlined style={{ fontSize: 15 }} />
          Delete
        </a>
      </Popconfirm>
    </div>
  );
  const deleteUser = async (record) => {
    let url = `${Config.url}clinic/${record.id}`
    try {
      const response = await axios.delete(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      })

      messageApi.success({
        type: 'succes',
        content: 'Clinic deleted successfully',
      });
      getAllClinicData(1)
    } catch (error) {
      messageApi.error({
        type: 'error',
        content: error.response?.data?.message || error.message ? error.response?.data?.message || error.message : 'Something went Wrong',
      });
      console.log('update :', error.response?.data?.message || error.message);
      // throw error;
    }
  }
  const itemRender = (_, type, originalElement) => {
    if (type === 'prev') {
      return <a style={{ color: '#4A4A4A' }}>Previous</a>;
    }
    if (type === 'next') {
      return <a style={{ color: '#4A4A4A' }}>Next</a>;
    }
    return originalElement;
  };
  const onFinish = async (values, update = false) => {
    if (values && values.price_bucket_id && values.price_bucket_id.value) {
      values.price_bucket_id = values.price_bucket_id.value
    }
    if (!clinicDataSetInUpdate?.clinic_website_description) {
      messageApi.error({
        type: 'error',
        content: 'Add clinic website description',
      });
      return
    } else if (!clinicDataSetInUpdate?.specific_email_copy) {
      messageApi.error({
        type: 'error',
        content: 'Add specific email copy',
      });
      return
    } else if (!clinicDataSetInUpdate?.specific_sms_copy) {
      messageApi.error({
        type: 'error',
        content: 'Add specific sms copy',
      });
      return
    }

    try {
      setIsSubmitting(true)

      if (!update) {
        let url = `${Config.url}clinic`, rooms = []
        let payload = {
          ...values,
          'status': 1,
          'is_hidden_from_main_widget': Boolean(values?.is_hidden_from_main_widget),
          "clinic_website_description": clinicDataSetInUpdate?.clinic_website_description ? clinicDataSetInUpdate?.clinic_website_description : undefined,
          "specific_email_copy": clinicDataSetInUpdate?.specific_email_copy ? clinicDataSetInUpdate?.specific_email_copy : undefined,
          "specific_sms_copy": clinicDataSetInUpdate?.specific_sms_copy ? clinicDataSetInUpdate?.specific_sms_copy : undefined,

        }
        if (values && values.rooms && values.rooms.length) {
          values.rooms.map(room => {
            rooms.push({
              "lantum_location_id": room.lantum_location_id,
              "semble_location_id": room.semble_location_id,
              "clinician_type": room.clinician_type,
            })
          })
          if (rooms && rooms.length) {
            payload = {
              ...payload,
              rooms
            }
          }
        }
        // return
        const response = await axios.post(url, payload, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });
        form.setFieldsValue({
          "name": '',
          "price_bucket_id": '',
          "website_url": '',
          "address": '',
          "longitude": '',
          "latitude": '',
          "rooms": '',
          status: '',
          is_hidden_from_main_widget: false
        });
        setclinicDataSet({})
        setloader(false)
        setIsSubmitting(false)
        getAllClinicData(1)
        setisClinicCreateEnable(false)
        messageApi.success({
          type: 'succes',
          content: 'Clinic added successfully',
        });
      } else {
        if (!clinicDataSetInUpdate.id) {
          setloader(false)
          return
        }

        let url = `${Config.url}clinic/${clinicDataSetInUpdate.id}`, rooms = []
        let payload = {
          ...values,
          'is_hidden_from_main_widget': Boolean(values?.is_hidden_from_main_widget),
          "clinic_website_description": clinicDataSetInUpdate?.clinic_website_description ? clinicDataSetInUpdate?.clinic_website_description : undefined,
          "specific_email_copy": clinicDataSetInUpdate?.specific_email_copy ? clinicDataSetInUpdate?.specific_email_copy : undefined,
          "specific_sms_copy": clinicDataSetInUpdate?.specific_sms_copy ? clinicDataSetInUpdate?.specific_sms_copy : undefined,

        }
        if (values && values.rooms && values.rooms.length) {
          values.rooms.map(room => {
            rooms.push({
              "lantum_location_id": room.lantum_location_id,
              "semble_location_id": room.semble_location_id,
              "clinician_type": room.clinician_type,
            })
          })
          if (rooms && rooms.length) {
            payload = {
              ...payload,
              rooms
            }
          }
        }
        const response = await axios.put(url, payload, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });
        form.setFieldsValue({
          "name": '',
          "price_bucket_id": '',
          "website_url": '',
          "address": '',
          "longitude": '',
          "latitude": '',
          "rooms": '',
          status: '',
          is_hidden_from_main_widget: false
        });
        setclinicDataSet({})
        setloader(false)
        setIsSubmitting(false)
        getAllClinicData(1)
        setisClinicCreateEnable(false)
        messageApi.success({
          type: 'succes',
          content: 'Clinic updated successfully',
        });
      }

    } catch (error) {
      setloader(false)
      setIsSubmitting(false)
      console.log(':error:::', error)
      messageApi.error({
        type: 'succes',
        content: error.response?.data?.message || error.message || 'Something Went wrong',
      });
    }
    setFormMode('edit')
    setloader(false)
    setIsSubmitting(false)
    setshowAddButton(true)
  }
  const clearCancelForm = () => {
    setFormMode('edit')
    setshowAddButton(true)
    form.setFieldsValue({
      "name": '',
      "price_bucket_id": '',
      "website_url": '',
      "address": '',
      "longitude": '',
      "latitude": '',
      "rooms": [{ lantum_location_id: "", semble_location_id: "" }],
      status: '',
      is_hidden_from_main_widget: false
    });
    setclinicDataSet({ rooms: { lantum_location_id: "", semble_location_id: "" } })
    setisClinicCreateEnable(false)
  }
  const validateURL = (_, value) => {
    try {
      if (!value || new URL(value)) {
        return Promise.resolve();
      }
    } catch (_) {
      return Promise.reject("Please enter a valid URL");
    }
  };
  const handleSearch = (e) => {
    if (e.target.value != '' && e.target.value?.trim() && e.target.value?.trim()?.length > 2) {
      setinputSearchValue(e.target.value)
    }
    if (e.target.value.length == 0) {
      setinputSearchValue('')
      getAllClinicData(CurrentPage, null, pageSize)
    }
  }
  return (
    <App>
      {contextHolder}
      <div style={{ display: 'grid', justifyContent: 'center' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 5 }}>
          {allClinicData && <div style={{ display: "flex", justifyContent: 'flex-start', alignItems: "center" }}>
            <Title level={5} style={{ margin: 0, color: "#008385", fontSize: 20, marginTop: '15px', alignItems: 'end', lineHeight: '1' }}>
              All Clinic <span style={{ color: "black", fontWeight: '400' }}>({allClinicData?.total ? allClinicData.total : '00'})</span>
            </Title>
          </div>
          }
          <div >
            <Input
              placeholder="Search for a clinic"
              prefix={<SearchOutlined />}
              allowClear
              onChange={handleSearch}
              style={{ width: 300, height: 45, borderColor: '#008385' }}
            />
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Card
            className='addClinic-table'
            style={{ width: 950, margin: 0, padding: 0, borderRadius: 50, boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)" }}
          >
            <ConfigProvider
              theme={{
                components: {
                  Table: {
                    headerBg: "#008385",
                    headerColor: "#ffffff",
                  },
                  Spin: {
                    colorPrimary: "#008385", // Change this to your desired color
                  },
                },
              }}
            >


              {allClinicData && (
                isSearchActive ? (
                  <Table
                    loading={loader}
                    columns={columns}
                    dataSource={allClinicData?.data}
                    pagination={false}
                    rowKey="id"
                    onRow={(record) => ({
                      onClick: () => openClinicRecord(record, true),
                    })}
                    scroll={{ x: 'auto' }}
                  />
                ) : (
                  <DndContext
                    sensors={sensors}
                    modifiers={[restrictToVerticalAxis]}
                    onDragEnd={onDragEnd}
                  >
                    <SortableContext
                      items={draggedData.map((i) => i.id)}
                      strategy={verticalListSortingStrategy}
                    >
                      <Table
                        loading={loader}
                        columns={columns}
                        dataSource={draggedData}
                        pagination={false}
                        rowKey="id"
                        components={{
                          body: {
                            row: DraggableRow,
                          },
                        }}
                        onRow={(record) => ({
                          onClick: () => openClinicRecord(record, true),
                        })}
                        scroll={{ x: 'auto' }}
                      />
                    </SortableContext>
                  </DndContext>
                )
              )}
              {allClinicData && allClinicData?.total ? <Pagination
                align="center"
                current={CurrentPage}
                pageSize={pageSize}
                total={allClinicData?.total}
                style={{ marginTop: 10 }}
                showSizeChanger
                pageSizeOptions={[10, 25, 50, 100]}
                onChange={(page, size) => {
                  setCurrentPage(page)
                  setPageSize(size)
                  getAllClinicData(page, isSearchActive ? debouncedInputValue : null, size)
                }}
                itemRender={itemRender}
              /> : ''}
            </ConfigProvider>
          </Card>
        </div>
      </div>
      {showAddButton && <div className='clinicCreate-form button-add-left' style={{ display: 'flex', justifyContent: 'flex-start', marginTop: 20 }}>
        <Button className='add-generic-btn' onClick={() => {
          setisClinicCreateEnable(true)
          setshowEditorOnlyAdd(true)
        }}>
          Add a clinic
        </Button>
      </div>}
      {isClinicCreateEnable && (() => {
        const initials = getInitials(clinicDataSetInUpdate?.name);
        const clinicName = clinicDataSetInUpdate?.name || 'New Clinic';
        return (
          <div style={{ display: 'flex', justifyContent: 'center', gap: 20, padding: 20 }}>
            {/* Left Side - Clinic Form */}
            <Card
              className={isViewMode ? 'clinician-view-mode-card' : ''}
              style={{
                width: 575,
                borderRadius: 16,
                boxShadow: '0 4px 16px rgba(0,0,0,0.10)',
                overflow: 'hidden',
              }}
              title={
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                  <div style={{
                    width: 38, height: 38, borderRadius: '50%',
                    background: 'linear-gradient(135deg, #008385, #00a3a5)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    color: '#fff', fontWeight: 700, fontSize: 15, flexShrink: 0,
                    boxShadow: '0 2px 6px rgba(0,131,133,0.30)',
                  }}>
                    {isViewMode ? initials : '+'}
                  </div>
                  <span style={{ fontWeight: 700, fontSize: 16, color: '#007a7c' }}>
                    {isViewMode ? clinicName : `${clinicDataSetInUpdate?.name || 'Clinic'} details`}
                  </span>
                </div>
              }
              extra={null}
            >
              {clinicDataSetInUpdate && loader === false && (
                <Form
                  form={form}
                  layout="vertical"
                  initialValues={clinicDataSetInUpdate || null}
                  onFinish={(values) => onFinish(values, clinicDataSetInUpdate?.id && Object.keys(clinicDataSetInUpdate)?.length ? true : false)}
                >
                  {isViewMode ? (
                    <div style={{ padding: '0 4px' }}>
                      {/* ── Core Details ── */}
                      <SectionDivider label="Clinic Details" />
                      <div className="clinician-view-detail-row">
                        <label>Name</label>
                        <span className="clinician-view-field-value">{clinicDataSetInUpdate?.name || '-'}</span>
                      </div>
                      <div className="clinician-view-detail-row">
                        <label>Price Bucket</label>
                        <span className="clinician-view-field-value">
                          {showPriceBucket?.[clinicDataSetInUpdate?.price_bucket_id] || clinicDataSetInUpdate?.price_bucket_id || '-'}
                        </span>
                      </div>
                      <div className="clinician-view-detail-row">
                        <label>Website URL</label>
                        <span className="clinician-view-field-value">{clinicDataSetInUpdate?.website_url || '-'}</span>
                      </div>
                      <div className="clinician-view-detail-row">
                        <label>Address</label>
                        <span className="clinician-view-field-value">{clinicDataSetInUpdate?.address || '-'}</span>
                      </div>
                      <div className="clinician-view-detail-row">
                        <label>Hide this clinic from main booking journey</label>
                        <Tag className="clinician-tag-pill" style={{
                          color: clinicDataSetInUpdate?.is_hidden_from_main_widget ? '#ff4d4f' : '#008385',
                          borderColor: clinicDataSetInUpdate?.is_hidden_from_main_widget ? '#ff4d4f' : '#008385',
                          background: clinicDataSetInUpdate?.is_hidden_from_main_widget ? '#fff1f0' : '#e6f5f5',
                        }}>
                          {clinicDataSetInUpdate?.is_hidden_from_main_widget ? 'Yes (Hidden)' : 'No (Visible)'}
                        </Tag>
                      </div>

                      {/* ── Location ── */}
                      <SectionDivider label="Location" />
                      <div className="clinician-view-detail-row">
                        <label>Longitude</label>
                        <span className="clinician-view-field-value">{clinicDataSetInUpdate?.longitude || '-'}</span>
                      </div>
                      <div className="clinician-view-detail-row">
                        <label>Latitude</label>
                        <span className="clinician-view-field-value">{clinicDataSetInUpdate?.latitude || '-'}</span>
                      </div>

                      {/* ── Status ── */}
                      {clinicDataSetInUpdate?.id && (
                        <>
                          <SectionDivider label="Status" />
                          <div className="clinician-view-detail-row">
                            <label>Status</label>
                            <Tag className="clinician-tag-pill" style={{
                              color: clinicDataSetInUpdate?.status == 1 ? '#008385' : '#ff4d4f',
                              borderColor: clinicDataSetInUpdate?.status == 1 ? '#008385' : '#ff4d4f',
                              background: clinicDataSetInUpdate?.status == 1 ? '#e6f5f5' : '#fff1f0',
                            }}>
                              {clinicDataSetInUpdate?.status == 1 ? 'Active' : 'Inactive'}
                            </Tag>
                          </div>
                        </>
                      )}

                      {/* ── Rooms ── */}
                      {clinicDataSetInUpdate?.rooms?.length > 0 && (
                        <>
                          <SectionDivider label="Rooms" />
                          {clinicDataSetInUpdate.rooms.map((room, index) => (
                            <div key={index} style={{ marginBottom: 8 }}>
                              <div style={{ fontSize: 11, fontWeight: 700, color: '#008385', marginBottom: 4, paddingLeft: 2 }}>Room {index + 1}</div>
                              <div className="clinician-view-detail-row">
                                <label>Lantum ID</label>
                                <span className="clinician-view-field-value">{room.lantum_location_id || '-'}</span>
                              </div>
                              <div className="clinician-view-detail-row">
                                <label>Semble ID</label>
                                <span className="clinician-view-field-value">{room.semble_location_id || '-'}</span>
                              </div>
                              <div className="clinician-view-detail-row">
                                <label>Type</label>
                                {productsData?.find(p => p.value === Number(room.clinician_type))?.label
                                  ? <Tag className="clinician-tag-pill">{productsData.find(p => p.value === Number(room.clinician_type)).label}</Tag>
                                  : <span className="clinician-view-field-value">{room.clinician_type || '-'}</span>
                                }
                              </div>
                            </div>
                          ))}
                        </>
                      )}

                      {/* ── View mode bottom actions ── */}
                      <div style={{ display: 'flex', justifyContent: 'center', gap: 12, marginTop: 20, paddingBottom: 4 }}>
                        <Button onClick={clearCancelForm} style={{ borderColor: '#008385', color: '#008385', minWidth: 100 }}>Cancel</Button>
                        <Button
                          className="edit-btn-green"
                          icon={<EditOutlined />}
                          onClick={() => setFormMode('edit')}
                          style={{ minWidth: 100 }}
                        >Edit</Button>
                      </div>
                    </div>
                  ) : (
                    <>
                      <Row gutter={16}>
                        <Col span={12}>
                          <Form.Item name="name" className='leftInputFields' rules={[{ required: true, message: "Name is required." }]}>
                            <Input placeholder="Name" />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item name="price_bucket_id" rules={[{ required: true, message: "Price bucket selection is required." }]}>
                            <Select placeholder="Price bucket">
                              {allbucketData && allbucketData.length && allbucketData.map(buc => (
                                <Option value={buc.value} key={buc.value}>{buc.label}</Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>

                      <Form.Item name="website_url" className='leftInputFields' rules={[
                        { required: true, message: "Website URL is required." },
                        { validator: validateURL },
                      ]}>
                        <Input placeholder="Website URL" />
                      </Form.Item>
                      <Form.Item name="address" rules={[{ required: true, message: "Address is required." }]}>
                        <Input placeholder="Address" />
                      </Form.Item>

                      <Form.Item
                        name="is_hidden_from_main_widget"
                        valuePropName="checked"
                        initialValue={false}
                        style={{ marginBottom: 16, textAlign: 'left' }}
                      >
                        <Checkbox style={{ color: '#4a4a4a', fontWeight: 500 }}>
                          Hide from main widget
                        </Checkbox>
                      </Form.Item>

                      <Row gutter={16}>
                        <Col span={12}>
                          <Form.Item name="longitude" rules={[
                            { required: true, message: "Longitude is required." },
                            { validator: (_, value) => (!value || /^-?\d*(\.\d+)?$/.test(value)) ? Promise.resolve() : Promise.reject(new Error("Must be a number.")) }
                          ]}>
                            <Input placeholder="Longitude" />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item name="latitude" rules={[
                            { required: true, message: "Latitude is required." },
                            { validator: (_, value) => (!value || /^-?\d*(\.\d+)?$/.test(value)) ? Promise.resolve() : Promise.reject(new Error("Must be a number.")) }
                          ]}>
                            <Input placeholder="Latitude" />
                          </Form.Item>
                        </Col>
                      </Row>

                      <hr />
                      <Form.List name="rooms" initialValue={[{ lantum_location_id: "", semble_location_id: "", clinician_type: productsData?.length ? productsData[0]?.value : undefined }]}>
                        {(fields, { add, remove }) => (
                          <>
                            {fields.map(({ key, name, ...restField }, index) => (
                              <div key={key}>
                                <span style={{ display: "block", textAlign: "start" }}>Room {index + 1}:</span>
                                <Row gutter={16}>
                                  <Col span={7}>
                                    <Form.Item {...restField} name={[name, "lantum_location_id"]} rules={[{ required: true, message: "Lantum ID is required." }]}>
                                      <Input placeholder="Lantum ID" />
                                    </Form.Item>
                                  </Col>
                                  <Col span={7}>
                                    <Form.Item {...restField} name={[name, "semble_location_id"]} rules={[{ required: true, message: "Semble ID is required." }]}>
                                      <Input placeholder="Semble ID" />
                                    </Form.Item>
                                  </Col>
                                  <Col span={7}>
                                    <Form.Item {...restField} name={[name, "clinician_type"]} rules={[{ required: true, message: "Room type is required." }]}>
                                      <Select defaultValue={productsData?.length ? productsData[0]?.value : undefined} placeholder="Select room type">
                                        {productsData?.map(clType => <Option value={clType.value} key={clType.value}>{clType.label}</Option>)}
                                      </Select>
                                    </Form.Item>
                                  </Col>
                                  {key > 0 && (
                                    <Col span={3}>
                                      <Form.Item {...restField}>
                                        <Button type="text" icon={<DeleteOutlined />} onClick={() => remove(name)} />
                                      </Form.Item>
                                    </Col>
                                  )}
                                </Row>
                              </div>
                            ))}
                            <Button type="default" className='add-generic-btn' onClick={() => add()} block>Add a room</Button>
                          </>
                        )}
                      </Form.List>

                      {clinicDataSetInUpdate?.id && Object.keys(clinicDataSetInUpdate)?.length ? (
                        <Space.Compact style={{ width: "100%", marginTop: 10 }}>
                          <Form.Item name="status" style={{ flex: 1 }} rules={[{ required: true, message: "Status selection is required" }]}>
                            <Select placeholder="Status">
                              <Option value="1">Active</Option>
                              <Option value="0">Inactive</Option>
                            </Select>
                          </Form.Item>
                        </Space.Compact>
                      ) : ''}

                      {/* Edit mode action buttons — centred */}
                      <div style={{ display: 'flex', justifyContent: 'center', gap: 12, marginTop: 16, paddingBottom: 4 }}>
                        <Button onClick={clearCancelForm} style={{ borderColor: '#008385', color: '#008385', minWidth: 100 }}>Cancel</Button>
                        <Button
                          htmlType="submit"
                          loading={isSubmitting}
                          disabled={isSubmitting}
                          style={{
                            backgroundColor: isSubmitting ? '#80bebe' : '#008385',
                            borderColor: isSubmitting ? '#80bebe' : '#008385',
                            color: '#fff',
                            cursor: isSubmitting ? 'not-allowed' : 'pointer',
                            minWidth: 100,
                          }}
                        >
                          {isSubmitting ? 'Saving...' : 'Apply'}
                        </Button>
                      </div>
                    </>
                  )}
                </Form>
              )}
            </Card>

            {/* Right Side - Text Areas */}
            {clinicDataSetInUpdate && (loader == false) && <Card style={{ width: 700, padding: 20 }}>
              {[
                { label: `${clinicDataSetInUpdate.name ? clinicDataSetInUpdate.name : `Clinic 1`} website description`, name: "clinic_website_description" },
                { label: `${clinicDataSetInUpdate.name ? clinicDataSetInUpdate.name : `Clinic 1`} specific email copy`, name: "specific_email_copy" },
                { label: `${clinicDataSetInUpdate.name ? clinicDataSetInUpdate.name : `Clinic 1`} specific SMS copy`, name: "specific_sms_copy" },
              ].map(({ label, name }, index) => (
                <div key={index} style={{ position: "relative", marginBottom: 15 }}>
                  <Form.Item >
                    <div style={{ textAlign: 'left', alignItems: 'flex-start', color: '#4a4a4a', marginBottom: 4, fontSize: 15 }}>
                      {label === `${clinicDataSetInUpdate.name ? clinicDataSetInUpdate.name : `Clinic 1`} website description` ? `${clinicDataSetInUpdate.name ? clinicDataSetInUpdate.name : `Clinic 1`} website description` : label === `${clinicDataSetInUpdate.name ? clinicDataSetInUpdate.name : `Clinic 1`} specific email copy` ? `${clinicDataSetInUpdate.name ? clinicDataSetInUpdate.name : `Clinic 1`} specific email copy` : label === `${clinicDataSetInUpdate.name ? clinicDataSetInUpdate.name : `Clinic 1`} specific SMS copy` ? `${clinicDataSetInUpdate.name ? clinicDataSetInUpdate.name : `Clinic 1`} specific SMS copy` : ''}
                    </div>
                    {isViewMode ? (
                      <div className='emailCopy' dangerouslySetInnerHTML={{ __html: label == `${clinicDataSetInUpdate.name ? clinicDataSetInUpdate.name : `Clinic 1`} website description` ? clinicDataSetInUpdate?.clinic_website_description : label == `${clinicDataSetInUpdate.name ? clinicDataSetInUpdate.name : `Clinic 1`} specific email copy` ? clinicDataSetInUpdate?.specific_email_copy : label == `${clinicDataSetInUpdate.name ? clinicDataSetInUpdate.name : `Clinic 1`} specific SMS copy` ? clinicDataSetInUpdate?.specific_sms_copy : '' }} />
                    ) : (
                      (editTextArea != label && !showEditorOnlyAdd) && <div className='emailCopy' dangerouslySetInnerHTML={{ __html: label == `${clinicDataSetInUpdate.name ? clinicDataSetInUpdate.name : `Clinic 1`} website description` ? clinicDataSetInUpdate?.clinic_website_description : label == `${clinicDataSetInUpdate.name ? clinicDataSetInUpdate.name : `Clinic 1`} specific email copy` ? clinicDataSetInUpdate?.specific_email_copy : label == `${clinicDataSetInUpdate.name ? clinicDataSetInUpdate.name : `Clinic 1`} specific SMS copy` ? clinicDataSetInUpdate?.specific_sms_copy : '' }} />
                    )}
                    {(!isViewMode && (editTextArea && editTextArea == label || showEditorOnlyAdd)) && <Editor
                      apiKey={Config.apiKey}
                      // onInit={(_evt, editor) => editorRef.current = editor}
                      onInit={(_evt, editor) => {
                        editorRef.current = editor;
                        const editorId = editor.id;
                        // Attach a label for char count
                        if (name == 'specific_sms_copy') {
                          editor.on('SkinLoaded', () => {
                            const textOnly = editor.getContent({ format: 'text' }) || '';
                            const remaining = Math.max(0, textOnly.length);
                            if (!charCountRefs.current[editorId]) {
                              const label = document.createElement('div');
                              label.style.marginTop = '0';
                              label.style.color = '#aaa';
                              label.style.textAlign = 'center';
                              label.innerText = `${remaining ?? 0}/${MAX_CHARS}`;
                              charCountRefs.current[editorId] = label;
                              const container = editor.getContainer();
                              if (container) {
                                container.appendChild(label);
                              }
                            }
                          });
                          // Prevent typing beyond limit
                          editor.on('keydown', (e) => {
                            const content = editor.getContent({ format: 'text' });
                            if (
                              content.length >= MAX_CHARS &&
                              ![8, 46, 37, 38, 39, 40].includes(e.keyCode)
                            ) {
                              e.preventDefault();
                            }
                          });
                        }
                      }}
                      value={label == `${clinicDataSetInUpdate.name ? clinicDataSetInUpdate.name : `Clinic 1`} website description` ? clinicDataSetInUpdate?.clinic_website_description : label == `${clinicDataSetInUpdate.name ? clinicDataSetInUpdate.name : `Clinic 1`} specific email copy` ? clinicDataSetInUpdate?.specific_email_copy : label == `${clinicDataSetInUpdate.name ? clinicDataSetInUpdate.name : `Clinic 1`} specific SMS copy` ? clinicDataSetInUpdate?.specific_sms_copy : ''}

                      init={{
                        height: 140,
                        width: 650,
                        marginTop: 50,
                        menubar: false,
                        plugins: [
                          'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                          'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                          'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                        ],
                        toolbar: label === `${clinicDataSetInUpdate.name ? clinicDataSetInUpdate.name : `Clinic 1`} specific SMS copy` ? 'undo redo | blocks |  link | unlink' : 'undo redo | blocks ' +
                          'bold italic forecolor | alignleft aligncenter ' +
                          'alignright alignjustify | bullist numlist outdent indent | ' +
                          'removeformat  ' + 'link | unlink',
                        content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                        placeholder: label === `${clinicDataSetInUpdate.name ? clinicDataSetInUpdate.name : `Clinic 1`} website description` ? `${clinicDataSetInUpdate.name ? clinicDataSetInUpdate.name : `Clinic 1`} website description` : label === `${clinicDataSetInUpdate.name ? clinicDataSetInUpdate.name : `Clinic 1`} specific email copy` ? `${clinicDataSetInUpdate.name ? clinicDataSetInUpdate.name : `Clinic 1`} specific email copy` : label === `${clinicDataSetInUpdate.name ? clinicDataSetInUpdate.name : `Clinic 1`} specific SMS copy` ? `${clinicDataSetInUpdate.name ? clinicDataSetInUpdate.name : `Clinic 1`} specific SMS copy` : '',
                      }}
                      onEditorChange={(newContent, editor) => {
                        // Only apply character limit to SMS copy
                        if (label === `${clinicDataSetInUpdate.name ? clinicDataSetInUpdate.name : `Clinic 1`} specific SMS copy`) {
                          const textOnly = editor.getContent({ format: 'text' }) || '';
                          const remaining = Math.max(0, textOnly.length);
                          const MAX_SMS_CHARS = 255; // SMS specific limit<p></P>
                          const used = textOnly.length;

                          //  console.log(`[${label}] Character count: ${used}`);

                          // Update character count display
                          const labelNew = charCountRefs.current[editor.id];
                          if (labelNew) {
                            labelNew.innerText = `${remaining}/${MAX_SMS_CHARS}`;
                          }

                          // Handle content exceeding SMS limit
                          if (textOnly.length > MAX_SMS_CHARS) {
                            const trimmed = textOnly.substring(0, MAX_SMS_CHARS);
                            editor.setContent(trimmed);
                            return; // Exit early after trimming
                          }
                        }

                        // Update state for all fields
                        setclinicDataSet((previousData) => {
                          const newData = { ...previousData };
                          if (label === `${clinicDataSetInUpdate.name ? clinicDataSetInUpdate.name : `Clinic 1`} website description`) {
                            newData.clinic_website_description = newContent;
                          } else if (label === `${clinicDataSetInUpdate.name ? clinicDataSetInUpdate.name : `Clinic 1`} specific email copy`) {
                            newData.specific_email_copy = newContent;
                          } else if (label === `${clinicDataSetInUpdate.name ? clinicDataSetInUpdate.name : `Clinic 1`} specific SMS copy`) {
                            newData.specific_sms_copy = newContent;
                          }
                          return newData;
                        });
                      }}
                    />}

                  </Form.Item>
                  {(editTextArea != label && !showEditorOnlyAdd && !isViewMode) && <EditOutlined
                    style={{
                      position: "absolute",
                      top: 30,
                      right: 10,
                      fontSize: 18,
                      color: "#999",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      seteditTextArea(label)
                    }
                    }
                  />}
                </div>
              ))}
            </Card>}
          </div>
        );
      })()}
    </App>
  )
}

export default Addclinic
